module.exports = __webpack_public_path__ + "img/Twitter_Icon.5749c238.svg";